import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPage() {
  return (
    <div className="agento-page">
      <nav className="agento-nav">
        <div className="agento-nav-inner">
          <Link to="/" className="agento-nav-brand">ZitotronTech</Link>
          <div className="agento-nav-links">
            <Link to="/agento">Agento</Link>
          </div>
        </div>
      </nav>

      <div className="legal-page">
        <div className="legal-content">
          <h1>Privacy Policy</h1>
          <p className="legal-effective">Effective Date: March 15, 2026</p>

          <p>
            Zito Tron Tech LLC ("Company", "we", "us", or "our") is committed to protecting
            your privacy. This Privacy Policy describes what information we collect, how we
            use it, and your rights regarding that information.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We collect only the minimum data necessary to provide our Services:</p>
          <ul>
            <li>
              <strong>Email address:</strong> Provided when you subscribe or sign up for
              notifications. Used for account management, license delivery, and service
              communications.
            </li>
            <li>
              <strong>Machine ID hash:</strong> A one-way hash of your machine identifier,
              used solely for license activation and device limit enforcement. We cannot
              reverse this hash to identify your hardware.
            </li>
            <li>
              <strong>Payment information:</strong> Payment is processed by Stripe. We do
              not store credit card numbers, bank account details, or other payment
              credentials on our servers. Stripe's privacy policy governs their handling
              of your payment data.
            </li>
          </ul>

          <h2>2. What We Do Not Collect</h2>
          <p>We believe in minimal data collection. We do not:</p>
          <ul>
            <li>Track your usage patterns or behavior within the application.</li>
            <li>Collect telemetry data.</li>
            <li>Use analytics services beyond what is necessary for licensing.</li>
            <li>Read, store, or transmit the contents of your terminal sessions.</li>
            <li>Sell, rent, or share your personal information with third parties for marketing purposes.</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>The information we collect is used exclusively to:</p>
          <ul>
            <li>Deliver and activate your software license.</li>
            <li>Manage your subscription and process payments.</li>
            <li>Communicate important service updates (e.g., security patches, billing issues).</li>
            <li>Respond to your support requests.</li>
          </ul>

          <h2>4. Data Retention</h2>
          <p>
            We retain your personal data only for as long as your account is active or as
            needed to provide you with our Services. If you cancel your subscription and
            request deletion of your account, we will delete your personal data within 30
            days, except where retention is required by law.
          </p>

          <h2>5. Your Rights (GDPR)</h2>
          <p>
            If you are located in the European Economic Area, you have the following rights
            under the General Data Protection Regulation:
          </p>
          <ul>
            <li><strong>Right of access:</strong> Request a copy of the personal data we hold about you.</li>
            <li><strong>Right to rectification:</strong> Request correction of inaccurate personal data.</li>
            <li><strong>Right to erasure:</strong> Request deletion of your personal data.</li>
            <li><strong>Right to data portability:</strong> Request your data in a machine-readable format.</li>
            <li><strong>Right to object:</strong> Object to the processing of your personal data.</li>
          </ul>
          <p>
            To exercise any of these rights, contact us at support@zitotrontech.com. We will
            respond to your request within 30 days.
          </p>

          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your
            personal data against unauthorized access, alteration, disclosure, or destruction.
            However, no method of transmission over the internet is 100% secure, and we
            cannot guarantee absolute security.
          </p>

          <h2>7. Third-Party Services</h2>
          <p>
            Our Services use Stripe for payment processing. Stripe operates under its own
            privacy policy, which you can review at stripe.com/privacy. We do not control
            and are not responsible for Stripe's data practices.
          </p>

          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of
            material changes by posting the updated policy on our website. Your continued
            use of our Services after any changes constitutes acceptance of the updated policy.
          </p>

          <h2>9. Contact</h2>
          <p>
            If you have questions about this Privacy Policy or wish to exercise your data
            rights, contact us at:
          </p>
          <p>
            Zito Tron Tech LLC<br />
            Email: support@zitotrontech.com
          </p>
        </div>
      </div>

      <footer className="agento-footer">
        <div className="container">
          <div className="agento-footer-content">
            <p>&copy; 2026 Zito Tron Tech LLC. All rights reserved.</p>
            <div className="agento-footer-links">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/agento/eula">EULA</Link>
              <a href="mailto:support@zitotrontech.com">support@zitotrontech.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPage;
